import amplitude from 'amplitude-js';
import { AmplitudeEvent, NavigationPayload } from '@/types/tradepending';
import { APP_CONFIG } from '@/common/config';
import { RouteMeta } from 'vue-router';

const amplitudeClient = amplitude.getInstance();

amplitudeClient.init(APP_CONFIG.AMPLITUDE_KEY);

export class AmplitudeService {
	public sendEvent(payload: AmplitudeEvent) {
		const eventDate = {
			Category: 'DigitalRetail',
			...payload,
		};

		amplitudeClient.logEvent(payload.Label, { ...eventDate });
	}

	public sendNavigationEvent(data: NavigationPayload) {
		const eventDate = {
			Category: 'DigitalRetail',
			Action: 'Navigation',
			Label: data.triggerType,
			DealerDomain: data.DealerDomain,
			...data.routeDetails,
		};

		amplitudeClient.logEvent('dropOff', { ...eventDate });
	}

	public sendSaveEvent(routeDetails: RouteMeta) {
		const eventDate = {
			Category: 'DigitalRetail',
			Action: 'Save',
			Label: 'Save',
			Description: 'Global save',
			...routeDetails,
		};

		amplitudeClient.logEvent('Save', { ...eventDate });
	}

	public async sendNavigationEventWithTimestamp(routeDetails: RouteMeta) {
		const eventData = {
			Category: 'DigitalRetail',
			Action: 'Navigation',
			DealerDomain: localStorage.DealerDomain,
			...routeDetails,
		};

		amplitudeClient.logEventWithTimestamp('Duration', { ...eventData });
	}
}
